// Module
var code = `<div appHeaderBar>
    <header-bar-title>Sign Up</header-bar-title>
</div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form name="RegistrationForm" id="RegistrationForm" #registrationForm="ngForm"  (submit)="submit()">
        <div class="HOA-misc-guidedSteps__container">
            <div class="HOA-container__header">
                <div class="HOA-container__header-text" tid="registerHeader">Sign Up - Register your property</div>
                <app-pmc-logo class="u-right" [property]="property" *ngIf="property || property.hoa.pmc.couponId"></app-pmc-logo>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-flextable-component__cell--mB30">
                    Enter Property IDs
                </div>
                <div class="HOA-container__content--borderNone">
                    <div class="HOA-flex-component HOA-flex-component--direction-column"
                         [ngClass]="[uiSelectedViewName === uiViewName_BY_ADDRESS ?
                                                    'HOA-registration-isOption1' :
                                                    'HOA-registration-isOption2']">

                        <div class="HOA-registration-ifOption1-show1st
                                            HOA-registration-ifOption2-show3rd
                                            HOA-registration-ifOption2-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_ADDRESS">
                            <app-address-form [property]="property"
                                              (invalidCheck)="invalidCheck(\$event.invalidObj)"
                                              [showPropertyNickname]="true"
                                              [setPropertyAddressEvent]="setPropertyAddressSubject.asObservable()">
                            </app-address-form>
                        </div>

                        <div class="HOA-registration-ifOption1-show3rd
                                            HOA-registration-ifOption2-show1st
                                            HOA-registration-ifOption1-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_IDS">
                            <div class="HOA-flex-component HOA-flex-component-sm-col-lg-row HOA-flextable-component__form" >
                                <app-property-form-left [anonymous]="true"
                                                        [disableInputsProperty]="disableInputsProperty"
                                                        [disablePropertyId]="disableInputsProperty"
                                                        (invalidCheck)="invalidCheck(\$event.invalidObj)"
                                                        class="HOA-flextable-component__form-vertical
                                                                       HOA-flextable-component__cell--alt50
                                                                       HOA-flextable-component__form--left"
                                                        [property]="property"
                                                        (blurFunction)="updateDefaultPropertyAddress()">
                                </app-property-form-left>
                                <div class="HOA-guest-payment-padding-helper
                                                    HOA-flextable-component__cell--alt50
                                                    HOA-flextable-component__form--right">
                                    <!-- This needs to stay so that the left stays correctly -->
                                </div>
                            </div>
                        </div>

                        <div class="HOA-registration-ifOption1-show3rd
                                            HOA-registration-ifOption2-show1st
                                            HOA-registration-ifOption1-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_ADDRESS">
                            <div id="unableToFindPropertyAnchor" class="u-pB8"
                                 [style.display]="(!(disableInputsProperty) && searched) ? 'block' : 'none'">
                                        <span>We were unable to locate your Property IDs, please use your statement or
                                            remittance slip to enter the information below.  If you do not have this
                                            information available, please contact your Property Management Company.
                                        </span>
                            </div>
                            <div class="HOA-flex-component
                                                HOA-flex-component-sm-col-lg-row
                                                HOA-flextable-component__form" >
                                <app-property-form-left id="propertyIdFormAnchor"
                                                        [anonymous]="true"
                                                        [disableInputsProperty]="disableInputsProperty"
                                                        [disablePropertyId]="disableInputsProperty"
                                                        class="HOA-flextable-component__form-vertical
                                                                        HOA-flextable-component__cell--alt50
                                                                        HOA-flextable-component__form--left"
                                                        [property]="property"
                                                        (blurFunction)="updateDefaultPropertyAddress()"
                                                        (invalidCheck)="invalidCheck(\$event.invalidObj)">
                                </app-property-form-left>
                                <div class="HOA-guest-payment-padding-helper
                                                    HOA-flextable-component__cell--alt50
                                                    HOA-flextable-component__form--right">
                                    <!-- This needs to stay so that the left stays correctly -->
                                </div>
                            </div>
                        </div>

                        <div class="HOA-registration-ifOption1-show1st
                                            HOA-registration-ifOption2-show3rd
                                            HOA-registration-ifOption2-hideIfCollapsed"
                             *ngIf="uiSelectedViewName === uiViewName_BY_IDS">
                            <!-- we need to be careful with dom order, this is a way to do so. -->
                            <div id="unableToFindAddressAnchor"
                                 class="u-pB8"
                                 [style.display]="(!(disableInputsProperty) &&
                                                            searched &&
                                                            uiSelectedViewName === uiViewName_BY_IDS) ? 'block' : 'none'">
                                        <span>
                                            We were unable to find your complete Property Address, please fill in your address below.
                                        </span>
                            </div>
                            <app-address-form id="addressFormAnchor"
                                              [property]="property"
                                              (invalidCheck)="invalidCheck(\$event.invalidObj)"
                                              [showPropertyNickname]="true"
                                              [setPropertyAddressEvent]="setPropertyAddressSubject.asObservable()">
                            </app-address-form>
                        </div>
                    </div>
                    <div class="HOA-Checking-Detail-button-container">
                        <button name="cancel"
                                id="cancel"
                                tid="cancel"
                                type="button"
                                class="Button Button--link"
                                (click)="cancel()">
                            Cancel
                        </button>
                        <button name="submit"
                                id="submit"
                                tid="submit"
                                type="submit"
                                class="Button Button--blue"
                                [disabled]="registrationForm.invalid || invalidCheckVar">Register
                            Property</button>
                    </div>
                    <div class="u-pT2
                                        HOA-flex-component
                                        HOA-font-fine-print">
                        <span class="asterisk-required">&#42;</span>
                        &nbsp;Indicates required field
                    </div>
                </div>
            </div>
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;